<template>
  <section>
    <div class="form-content">
      <div class="clear">
        <el-col :span="10">
          <el-form-item label="申请单位">
            <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请部门">
            <el-input size="small" :disabled="true" v-model="userData.childDept"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请人">
            <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
          </el-form-item>
        </el-col>
      </div>

      <div class="clear">
        <el-col :span="12">
          <el-form-item label="车辆类型">
            <el-select @change="forceUpdate" size="small" v-model="form.carType" placeholder="请选择">
              <el-option v-for="item in carType" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用车日期">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.useTime" type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </div>
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="项目名称">
            <el-input size="small" v-model="form.xmName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用车人">
            <div class="contact-user-list">
              <div class="user-item" v-for="user,i in selectLeader">
                <span class="name">{{user.name}}</span>
                <span @click="deleteUsers(i)" class="iconfont icon-close1"></span>
              </div>
            </div>
            <el-button @click="addUsers()" size="mini" type="primary">选择人员</el-button>
          </el-form-item>
        </el-col>
      </div>

      <el-form-item label="起止时间">
        <el-date-picker v-model="form.time" size="small" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>



    </div>
  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['formByFather', 'userData', ],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    data() {
      return {
        form: {},
        selectLeader: "",
        selectType: 0,
        carType: ['发电车', '挖掘机', '送水车', '动力站'],

        userDeptId: "",
      }
    },
    created() {
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      // this.getCarLists()
    },
    mounted() {
      this.form = this.formByFather
      if (this.form.driver) {
        this.selectLeader = [this.form.driver]
      }
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 返回form
      getFromData() {
        return this.form
      },
      // 添加驾驶员
      addUsers() {

        let _sr = this.selectLeader
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactApprovalItem', false)

        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', true)

        setTimeout(() => {
          this.selectType = 3
        }, 500)
      },
    },
    watch: {
      contactSelectArr() {
        if (this.selectType == 3) {
          this.selectLeader = this.contactSelectArr
          this.selectType = 0
        }
      },
      selectLeader() {
        this.form.driverId = this.selectLeader[0] ? this.selectLeader[0].id : ''
      },
      formByFather() {
        this.form = this.formByFather
        this.selectLeader = [this.form.driver]
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/car/control.vue